/*
 * SAM4S manuals: download measurement and model search (2026-10-08).
 *
 * Every manual, guide and brochure is rendered server-side by
 * snippets/sam4s-document-card.liquid, so the page works with JavaScript off.
 * This file only (1) reports a download click to the theme's analytics so GA4
 * can count manual downloads per document and model, and (2) filters the
 * manual library's model cards as the visitor types a model number.
 *
 * ON LEADS: a download is not a lead and a search is not a lead. Neither event
 * carries lead: true, and what the visitor typed is never sent - only how many
 * models matched.
 */
(function () {
  function emit(event, payload) {
    var data = Object.assign({}, payload || {}, { event: event, page: window.location.pathname });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      try { window.Shopify.analytics.publish(event, data); } catch (e) { /* analytics must never break the page */ }
    }
    if (window.S4SGA4Forward) window.S4SGA4Forward(event, data);
  }

  function bindDownloads() {
    if (document.documentElement.dataset.s4mdReady) return;
    document.documentElement.dataset.s4mdReady = '1';
    document.addEventListener('click', function (event) {
      var target = event.target.closest ? event.target.closest('[data-s4md-event]') : null;
      if (!target) return;
      // One event name, stated here rather than trusted from markup, so the
      // GA4 forwarder's allow-list and this file cannot drift apart.
      emit('s4s_manual_download', {
        document_title: target.dataset.doc || null,
        document_type: target.dataset.docType || null,
        model: target.dataset.model || null,
        host: target.dataset.host || null,
        lead: false,
      });
    });
  }

  function normalise(s) {
    return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function initSearch(root) {
    if (root.dataset.s4mlReady) return;
    root.dataset.s4mlReady = '1';
    var input = root.querySelector('[data-s4ml-search]');
    if (!input) return;
    var cards = [].slice.call(root.querySelectorAll('[data-s4ml-model]'));
    var count = root.querySelector('[data-s4ml-count]');
    var nomatch = root.querySelector('[data-s4ml-nomatch]');
    var timer = null;

    function haystack(card) {
      var docs = [].slice.call(card.querySelectorAll('[data-s4ml-doc-title]')).map(function (d) { return d.dataset.s4mlDocTitle; });
      return normalise([card.dataset.s4mlModel, card.dataset.s4mlTitle].concat(docs).join(' '));
    }

    function apply() {
      var q = normalise(input.value);
      var shown = 0;
      cards.forEach(function (card) {
        var hit = q === '' || haystack(card).indexOf(q) > -1;
        card.hidden = !hit;
        if (hit) shown++;
      });
      // A group (for example the older-models block) disappears when none of its cards match.
      [].slice.call(root.querySelectorAll('[data-s4ml-group]')).forEach(function (group) {
        var any = [].slice.call(group.querySelectorAll('[data-s4ml-model]')).some(function (c) { return !c.hidden; });
        group.hidden = !any;
      });
      if (count) count.textContent = q === '' ? '' : (shown === 1 ? '1 match' : shown + ' matches');
      if (nomatch) nomatch.hidden = !(q !== '' && shown === 0);
      if (q !== '') {
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          emit('s4s_manual_search', { result_count: shown, has_results: shown > 0, lead: false });
        }, 900);
      }
    }

    // After the visitor stops typing (or taps a quick pick), bring the result into view if its download button
    // would otherwise sit below the fold: the store header and breadcrumb take a third of a laptop screen.
    var revealTimer = null;
    function reveal() {
      if (revealTimer) window.clearTimeout(revealTimer);
      revealTimer = window.setTimeout(function () {
        if (!input.value) return;
        var first = cards.filter(function (c) { return !c.hidden; })[0];
        var btn = first && first.querySelector('a.s4dl__btn');
        if (!btn) return;
        if (btn.getBoundingClientRect().bottom > window.innerHeight - 24) {
          var box = input.closest('.s4fnd__search') || input;
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          box.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
        }
      }, 350);
    }

    input.addEventListener('input', function () { apply(); reveal(); });
    input.addEventListener('search', function () { apply(); reveal(); });

    // Quick picks fill the search box (same filter, same analytics: only the result count is ever reported).
    [].slice.call(root.querySelectorAll('[data-s4ml-chip]')).forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.getAttribute('data-s4ml-chip') || '';
        apply();
        reveal();
        try { input.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
      });
    });

    // "Older models" is a jump link to a block the search box can hide. With a model typed that matches no older
    // card the block is display:none, so the jump went nowhere (a Clarity dead click, 2026-10-27). Clear the search
    // first so the block is visible when the browser follows the link; the link itself is not intercepted.
    [].slice.call(root.querySelectorAll('[data-s4ml-older-link]')).forEach(function (link) {
      link.addEventListener('click', function () {
        if (!input.value) return;
        input.value = '';
        apply();
      });
    });
  }

  function boot() {
    bindDownloads();
    [].slice.call(document.querySelectorAll('[data-s4ml]')).forEach(initSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
